import { ShowWithTourType } from '@api';
import { formatDate } from '@common';
import { Text } from '@mantine/core';

type DatePropsType = {
  date: ShowWithTourType['showDate'];
};

export const Date: React.FC<DatePropsType> = ({ date }) => {
  return <Text>{formatDate(date)}</Text>;
};
